import React from "react";

function LoadingPost() {
  return (
    <>
      {[1,2,3,4].map((e, i)=>
      <div key={i} className="w-full bg-white rounded-2xl overflow-hidden shadow-lg">
        <div className="h-[200px] w-full bg-gray-200 animate-pulse" />
        <div className="p-5 space-y-4">
          <div className="h-6 bg-gray-200 rounded animate-pulse w-3/4" />
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6" />
          </div>
          <div className="flex items-center gap-4 justify-between">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
            <div className="h-6 bg-gray-200 rounded animate-pulse w-20" />
          </div>
        </div>
      </div>
      )}
    </>
  );
}

export default LoadingPost;
